import React, { useEffect } from "react";
import { Container } from "react-bootstrap";

import "./Contact.css";

function Contact() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px 60px 0px"
      }
    );

    const elements = document.querySelectorAll(
      ".contact-section .scroll-reveal"
    );

    elements.forEach((element) => {
      observer.observe(element);
    });

    return () => {
      elements.forEach((element) => {
        observer.unobserve(element);
      });

      observer.disconnect();
    };
  }, []);

  const emailAddress = "onyangostephen294@gmail.com";

  const whatsappMessage =
    "Hi Stephen, I viewed your portfolio and would like to discuss an opportunity.";

  const whatsappLink = `https://wa.me/254792638442?text=${encodeURIComponent(
    whatsappMessage
  )}`;

  return (
    <section
      className="contact-section"
      id="contact"
      aria-labelledby="contact-title"
    >
      <Container>
        <div className="contact-panel scroll-reveal">
          <span className="contact-eyebrow">
            Contact
          </span>

          <h2
            className="contact-title"
            id="contact-title"
          >
            Let&apos;s Discuss an{" "}
            <span>Opportunity</span>
          </h2>

          <p className="contact-description">
            I&apos;m open to cybersecurity, systems administration,
            enterprise networking, infrastructure support, and selected
            freelance opportunities.
          </p>

          <div className="contact-actions">
            <a
              href={`mailto:${emailAddress}`}
              className="contact-primary-action"
            >
              Send an Email
              <span aria-hidden="true">→</span>
            </a>

            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-secondary-action"
            >
              Message on WhatsApp
              <span aria-hidden="true">↗</span>
            </a>
          </div>

          <div className="contact-meta">
            <span>Nairobi, Kenya</span>

            <span
              className="contact-meta-divider"
              aria-hidden="true"
            />

            <span>
              Open to remote and on-site opportunities
            </span>
          </div>

          <div className="contact-links">
            <a
              href="https://linkedin.com/in/stephen-onyango-560342236/"
              target="_blank"
              rel="noopener noreferrer"
            >
              LinkedIn
              <span aria-hidden="true">↗</span>
            </a>

            <a
              href="https://github.com/stonyango294"
              target="_blank"
              rel="noopener noreferrer"
            >
              GitHub
              <span aria-hidden="true">↗</span>
            </a>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default Contact;